import { useCallback, useState } from 'react';

interface UseAvPreviewResult {
  previewAvId: string | null;
  onOpenPreview: (avId: string) => void;
  onClosePreview: () => void;
}

export const useAvPreview = (): UseAvPreviewResult => {
  const [previewAvId, setPreviewAvId] = useState<string | null>(null);
  const onOpenPreview = useCallback((avId: string) => setPreviewAvId(avId), []);
  const onClosePreview = useCallback(() => setPreviewAvId(null), []);
  return { previewAvId, onOpenPreview, onClosePreview };
};
